
export function extractOutcode(postcode = '') {
  // Extract the first part of postal code until the first whitespace character
  // Considere the postcode for the UK (E.g. YO1 9UA -> outcode = YO1)
  return postcode.split(' ', 1)[0];
}

export function URLOfEnclosingWebPage() {
  let url = undefined;

  // React App is being loaded inside an iframe
  if ( window.self !== window.top ) {
    url = document.referrer;
  }

  return url;
}
